<template>
    <div>
        <tabs
            :items="sections"
            :active-item="section"
            class="mb-3"
            @item-change="section = $event"
        />
        <general
            v-if="section.value === 'general'"
            v-model="content"
            :v="$v.content"
        />

        <users
            v-if="section.value === 'users'"
            :value="content"
            :v="$v.content"
            :server-errors="serverErrors"
            @campus-change="$emit('campus-change', $event)"
            @input="onInput"
        />
    </div>
</template>

<script>
import Base from '@/components/contents/Base';
import Tabs from '@/components/elements/Tabs';
import General from '@/components/about/General';
import Users from '@/components/about/Users';
import { required, email } from 'vuelidate/lib/validators';

const userValidators = {
    $each: {
        users: {
            $each: {
                fullName: {
                    required
                },

                email: {
                    required,
                    email
                },

                position: {
                    required
                }
            }
        }
    }
};

export default {
    components: {
        Tabs,
        Users,
        General
    },

    extends: Base,

    validations: {
        content: {
            title: {
                required
            },
            campusId: {
                required
            },
            commonGroups: { ...userValidators },
            groups: { ...userValidators }
        }
    },

    data() {
        return {
            sections: [
                {
                    value: 'general',
                    text: 'General'
                },
                {
                    value: 'users',
                    text: 'Users'
                }
            ],
            section: { value: 'general', text: 'General' }
        };
    },

    methods: {
        onInput(content) {
            this.content = { ...content };
        }
    }
};
</script>
